// src/components/practice/tasks/SpeakingOrInfoTransferTask.jsx
import React from 'react';
import { Mic } from 'lucide-react';

const SpeakingOrInfoTransferTask = ({ partData }) => {
    const task = partData.task;
    return (
        <div>
            <h4 className="font-bold text-lg mb-4 flex items-center">
                <Mic className="mr-2" />Sprechen / Notizen
            </h4>
            <div className="bg-gray-50 p-4 rounded-lg prose max-w-none">
                {task?.planningScenario && <p className="mb-2">{task.planningScenario}</p>}
                {task?.scenario && <p className="mb-2">{task.scenario}</p>}
                {task?.discussionPrompt && <p className="mb-2">{task.discussionPrompt}</p>}
                {task?.inputContent && <p className="italic bg-white p-3 rounded">{task.inputContent}</p>}
                {task?.guidingPoints && (
                    <div className="mt-4">
                        <h5 className="font-semibold">Stichpunkte:</h5>
                        <ul className="list-disc list-inside mt-2 space-y-1">
                            {task.guidingPoints.map((point, i) =>
                                <li key={i}>{typeof point === 'object' ? point.text : point}</li>
                            )}
                        </ul>
                    </div>
                )}
                {task?.topics && (
                    <div className="mt-4">
                        <h5 className="font-semibold">Themenauswahl:</h5>
                        <div className="space-y-2 mt-2">
                            {task.topics.map(topic => (
                                <div key={topic.id} className="p-3 bg-white rounded border">
                                    <p className="font-bold">{topic.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SpeakingOrInfoTransferTask;